import { render, staticRenderFns } from "./CrearProceso.vue?vue&type=template&id=b4140bc4&scoped=true"
import script from "./CrearProceso.vue?vue&type=script&lang=js"
export * from "./CrearProceso.vue?vue&type=script&lang=js"
import style0 from "./CrearProceso.vue?vue&type=style&index=0&id=b4140bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4140bc4",
  null
  
)

export default component.exports